import { ApiController, LocationEndPoint, DEFAULT_SIZE_REQUEST } from 'config';
import { ICountry, ILocationContent } from 'interfaces';
import { get } from '..';

export const getLocations = (params?: string) =>
  get({
    url: `/${ApiController.location}?size=${DEFAULT_SIZE_REQUEST}${
      params ?? ''
    }`,
  });

export const getLocationsByCountry = (country: string) =>
  get<ILocationContent>({
    url: `/${ApiController.location}/${LocationEndPoint.country}?country=${country}&size=200`,
  });

export const getCountryList = () =>
  get<ICountry[]>({
    url: `/${ApiController.country}`,
  });
